import { Box, Flex } from '@mantine/core';
import { useProcessAnalysisStore } from '../../../../store/process-analysis-store/process-analysis-store';
import {
  setActivePanel,
  setMultipleViewMode,
  setViewMode,
} from '../../../../store/process-analysis-store/process-analysis-store.actions';
import { useComparisonMode } from '../../../../store/process-analysis-store/process-analysis-store.hooks';
import { skyLightest } from '../../../../styles/design-tokens';
import { Select } from '../../../../ui-library/select/select';
import { SmallSquareButton } from '../../../../components/small-square-button/small-square-button';
import { useMultipleViewModeOptions, useSingleViewModeOptions } from '../../process-analysis.hooks';
import { ComparisonMode, MultipleViewMode, ViewMode } from '../../process-analysis.type';

export const FiltersHeader = () => {
  const viewMode = useProcessAnalysisStore((state) => state.viewMode);
  const multipleViewMode = useProcessAnalysisStore((state) => state.multipleViewMode);

  const comparisonMode = useComparisonMode();

  const singleViewModeOptions = useSingleViewModeOptions();
  const multipleViewModeOptions = useMultipleViewModeOptions();

  const viewModeOptions = comparisonMode === ComparisonMode.Single ? singleViewModeOptions : multipleViewModeOptions;
  const viewModeValue = comparisonMode === ComparisonMode.Single ? viewMode : multipleViewMode;
  const handleViewModeChange = (value: ViewMode | MultipleViewMode) => {
    if (comparisonMode === ComparisonMode.Single) {
      setViewMode(value as ViewMode);
    } else {
      setMultipleViewMode(value as MultipleViewMode);
    }
  };

  const viewModeSelect = (
    <Select
      size="sm"
      options={viewModeOptions}
      value={viewModeValue}
      onChange={(value) => handleViewModeChange(value as ViewMode | MultipleViewMode)}
    />
  );

  return (
    <Flex gap={8}>
      <Box style={{ flex: 1 }}>{viewModeSelect}</Box>
      <SmallSquareButton
        onClick={() => setActivePanel(null)}
        iconName="arrow_back_ios"
        style={{ backgroundColor: skyLightest }}
      />
    </Flex>
  );
};
